export class SortUtilityService {
	static sort(
		toSort: Array<any>,
		reverse: boolean,
		key?: string,
		nestedKey?: string
	): Array<any> {
		// Sorting strings with mixed casings at the start throws off sorting, let's
		// standardize the casing for the sort
		const baselineSortValue = (value) => {
			if (typeof value === 'string') {
				return value.toUpperCase();
			}

			return value;
		};
		// Protect in the case of just one item and falsy value
		if (!toSort) {
			return [];
		}
		if (toSort.length > 1) {
			return toSort.sort((a, b) => {
				let firstElementCheckValue;
				let secondElementCheckValue;
				if (nestedKey) {
					firstElementCheckValue =
						key ? baselineSortValue(a[nestedKey][key]) : baselineSortValue(a);
					secondElementCheckValue =
						key ? baselineSortValue(b[nestedKey][key]) : baselineSortValue(b);
				} else {
					firstElementCheckValue =
						key ? baselineSortValue(a[key]) : baselineSortValue(a);
					secondElementCheckValue =
						key ? baselineSortValue(b[key]) : baselineSortValue(b);
				}
				const reversed = reverse ? 1 : -1;
				// Stop sorting if all items are the same, if not apply the sort
				if (secondElementCheckValue === firstElementCheckValue) {
					return 0;
				}
				if (
					firstElementCheckValue === null ||
					firstElementCheckValue === '' ||
					firstElementCheckValue === undefined
				) {
					// nulls sort after anything else
					return 1;
				}
				if (
					secondElementCheckValue === null ||
					secondElementCheckValue === '' ||
					secondElementCheckValue === undefined
				) {
					// nulls sort after anything else
					return -1;
				}
				if (secondElementCheckValue > firstElementCheckValue) {
					return reversed;
				}

				return -reversed;
			});
		}

		return toSort;
	}
}
